import React from "react";
import "./MarketPlace.css";
import MarketplaceHero from "./marketplaceHero/MarketplaceHero";
import NftDevelopment from "./nftdevelopment/NftDevelopment";
import Build from "./build/Build";
import Cases from "./cases/Cases";
import Revenue from "./revenue/Revenue";
import NftChoose from "./nftchoose/NftChoose";
import Craft from "./craft/Craft";
import Testimonial from "./testimonialmarketplace/Testimonial";
import Service from "./servicemarketplace/Service";

export default function MarketPlace() {
  return (
    <div className="marketplace">
      <MarketplaceHero />
      <Revenue />
      <NftDevelopment />
      <NftChoose />
      <Craft />
      <Build />
      <Cases />
     <Testimonial/>
     <Service/>
    </div>
  );
}
